const shouldReturnEmptyString = (schema = {}) =>
	schema.type === 'string' ||
	(Array.isArray(schema.type) && schema.type.indexOf('string') !== -1) ||
	(schema.oneOf && schema.oneOf.find(({type}) => type === 'string'));

/**
 * @private
 * @param {*} value
 * @param {*} defaultValue
 * @returns resolved safe string value
 */
const fetchSafeStringValue = (value, defaultValue) => {
	if (value || defaultValue === undefined) return value;

	return defaultValue;
};

/**
 * @private
 * @param {*} propertyDefinition
 * @param {*} values
 * @param {*} defaultValue
 * @returns resolved value
 **/
const resolveValue = (propertyDefinition, values, defaultValue) => {
	const {length: valueCount} = values;
	var hasSchema = propertyDefinition?.schema;

	for (let i = 0; i < valueCount; i++) {
		const value = values[i];
		if (typeof value === 'string') {
			if (!hasSchema) return fetchSafeStringValue(value, defaultValue);
			else if (
				value.length ||
				(propertyDefinition.schema && shouldReturnEmptyString(propertyDefinition.schema))
			)
				return value;
		} else {
			if (value !== undefined && !propertyDefinition.readOnly) return value;
		}
	}

	return defaultValue;
};

export default function resolveProperties(
	state = {properties: {}},
	propertyDefinitions,
	instanceProperties = {}
) {
	const resolvedProperties = {};

	for (const k in propertyDefinitions) {
		resolvedProperties[k] = resolveValue(
			propertyDefinitions[k],
			[instanceProperties[k], state.properties[k]],
			propertyDefinitions[k].default
		);
	}

	return resolvedProperties;
}
